import { createContext } from "react";
const VideoOrderContext = createContext();
export default VideoOrderContext;

